import React from "react";
import dayjs from "dayjs";
import ErrorField from "../../../Components/ErrorField";
import DatePickerComponent from "../../../Components/DatePickerComponent";
import { cleanDecimalInput } from "../../../Helpers/Utilities";
import {
  CommonError_Msgs,
  NDMMTreatmentCohort_Msgs,
} from "../../../Helpers/HelperText";
import { NDMMPhasesId } from "../../../Helpers/Enums";

const NDMMDosageModification = ({
  questionNumber,
  phaseId,
  agentName,
  agentBridgeId,
  agentFirstDate,
  agentLastDate,
  endOfFollowUpDate,
  dosageList,
  onDosageChange,
  onDosageDateChange,
  onAddRow,
  onDeleteRow,
}) => {
  const GetOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const getTherapyName = () => {
    switch (phaseId) {
      case 1:
        return "induction therapy";
      case 2:
        return "consolidation therapy";
      case 3:
        return "maintenance therapy";
      case 4:
        return "1L treatment";
      default:
        return "therapy";
    }
  };

  return (
    <div className="dosage-modification-section">
      {/* Question Header */}
      <div className="question question-weight">
        <span>{questionNumber}.</span>
        <span className="quest-text-pad">
          Please provide information on all{" "}
          <u>
            <i>lenalidomide dose strength modifications</i>
          </u>{" "}
          that occurred during{" "}
          <u>
            <i>{getTherapyName()}</i>
          </u>
          .
        </span>
      </div>

      {/* Table Structure */}
      {dosageList && dosageList.length > 0 && (
        <div className="question-bot-sapce">
          <div className="dependent-section">
            {dosageList.map((childRow, childIdx) => (
              <div className="loop-section-ul" key={childIdx}>
                {/* Episode Header with Delete Button */}
                <div className="loop-head">
                  <span className="question-weight">
                    {GetOrdinal(childIdx + 1)} lenalidomide dose strength
                    modification
                  </span>
                  {childIdx !== 0 && (
                    <div className="delete-btn-div">
                      <img
                        width="16px"
                        src="../Assets/images/Icon-material-delete.png"
                        alt="Delete"
                        onClick={() => onDeleteRow(childIdx)}
                      />
                    </div>
                  )}
                </div>

                {/* Episode Content - Table */}
                <div className="question-bot-sapce">
                  <div className="sub-question grid-overflow">
                    <table
                      style={{
                        border: "1px solid black",
                        borderCollapse: "collapse",
                        width: "100%",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                              width: "33%",
                            }}
                          >
                            Date of lenalidomide dose strength modification
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                              width: "33%",
                            }}
                          >
                            Dose strength <i><u>before</u></i> modification 
                          </th>
                          <th
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              textAlign: "center",
                              width: "33%",
                            }}
                          >
                            Dose strength <i><u>after</u></i> modification
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {/* ===== COLUMN A - Date of Modification ===== */}
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              verticalAlign: "top",
                            }}
                          >
                            <div>
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={childIdx}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblA_${childIdx}`}
                                    value="1"
                                    checked={
                                      childRow.doseStrengthReceivedRadio === 1
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthReceivedRadio",
                                      )
                                    }
                                  />
                                  <span className="radio-text-padding">
                                    No lenalidomide dose strength modification
                                    occurred
                                  </span>
                                </label>
                              </div>
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={childIdx}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblA_${childIdx}`}
                                    value="2"
                                    checked={
                                      childRow.doseStrengthReceivedRadio === 2
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthReceivedRadio",
                                      )
                                    }
                                  />
                                  <span className="radio-text-padding">
                                    <DatePickerComponent
                                      ctrlId={`q${questionNumber.replace(/\./g, "")}_dateA_${childIdx}`}
                                      HandleDateChange={(name, date) =>
                                        onDosageDateChange(name, date, childIdx)
                                      }
                                      optionId={childIdx}
                                      date={childRow.doseStrengthReceivedDate}
                                      minDate={dayjs("01-01-1920")}
                                      maxDate={dayjs()}
                                      locale="en"
                                    />
                                  </span>
                                </label>
                              </div>
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={childIdx}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblA_${childIdx}`}
                                    value="99"
                                    checked={
                                      childRow.doseStrengthReceivedRadio === 99
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthReceivedRadio",
                                      )
                                    }
                                  />
                                  <span className="radio-text-padding">
                                    Date of modification unknown
                                  </span>
                                </label>
                              </div>
                            </div>

                            {/* Column A Validations */}
                            <ErrorField
                              show={childRow.showColAError}
                              message={
                                NDMMTreatmentCohort_Msgs.radioOptionError
                              }
                              style={{ paddingLeft: "0px" }}
                            />
                            <ErrorField
                              show={childRow.showColADateEmptyError}
                              message={
                                NDMMTreatmentCohort_Msgs.lenalidomideDateError
                              }
                              style={{ paddingLeft: "0px" }}
                            />
                            <ErrorField
                              show={childRow.showColAInvalidDate}
                              message={CommonError_Msgs.InvalidDate}
                              style={{ paddingLeft: "0px" }}
                            />
                            <ErrorField
                              show={
                                childRow.showColABeforeFirstDateError ||
                                childRow.showColAAfterLastDateError
                              }
                              // message={`Date must be on or after first administration date`}
                              message={
                                phaseId === NDMMPhasesId.InductionTherapy
                                  ? NDMMTreatmentCohort_Msgs.q22LenoADateOutOfBondError
                                  : phaseId ===
                                      NDMMPhasesId.ConsolidationTherapy
                                    ? NDMMTreatmentCohort_Msgs.q23LenoADateOutOfBondError
                                    : NDMMTreatmentCohort_Msgs.q24LenoADateOutOfBondError
                              }
                              style={{ paddingLeft: "0px" }}
                            />
                          </td>

                          {/* ===== COLUMN B - Dose Before Modification ===== */}
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              verticalAlign: "top",
                            }}
                          >
                            <div>
                              {/* mg */}
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={`${childIdx}_b_1`}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblB_${childIdx}`}
                                    value="1"
                                    checked={
                                      childRow.doseStrengthBeforeRadio === 1
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthBeforeRadio",
                                      )
                                    }
                                  />
                                  <input
                                    className="sub-input-dash"
                                    type="text"
                                    value={
                                      childRow.doseStrengthBeforeRadio === 1
                                        ? childRow.doseStrengthBeforeUnit || ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      // Step 1: Select this radio
                                      onDosageChange(
                                        { target: { value: "1" } },
                                        childIdx,
                                        "doseStrengthBeforeRadio",
                                      );
                                      // Step 2: Update value with validation
                                      onDosageChange(
                                        {
                                          target: {
                                            value: cleanDecimalInput(
                                              e.target.value,
                                            ),
                                          },
                                        },
                                        childIdx,
                                        "doseStrengthBeforeUnit",
                                      );
                                    }}
                                    maxLength={10}
                                    style={{
                                      width: "80px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                  <span className="radio-text-padding">
                                    {" "}
                                    mg
                                  </span>
                                </label>
                              </div>

                              {/* mg/kg */}
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={`${childIdx}_b_2`}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblB_${childIdx}`}
                                    value="2"
                                    checked={
                                      childRow.doseStrengthBeforeRadio === 2
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthBeforeRadio",
                                      )
                                    }
                                  />
                                  <input
                                    className="sub-input-dash"
                                    type="text"
                                    value={
                                      childRow.doseStrengthBeforeRadio === 2
                                        ? childRow.doseStrengthBeforeUnit || ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      // Step 1: Select this radio
                                      onDosageChange(
                                        { target: { value: "2" } },
                                        childIdx,
                                        "doseStrengthBeforeRadio",
                                      );
                                      // Step 2: Update value with validation
                                      onDosageChange(
                                        {
                                          target: {
                                            value: cleanDecimalInput(
                                              e.target.value,
                                            ),
                                          },
                                        },
                                        childIdx,
                                        "doseStrengthBeforeUnit",
                                      );
                                    }}
                                    maxLength={10}
                                    style={{
                                      width: "80px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                  <span className="radio-text-padding">
                                    {" "}
                                    mg/kg
                                  </span>
                                </label>
                              </div>

                              {/* mg/m² */}
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={`${childIdx}_b_3`}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblB_${childIdx}`}
                                    value="3"
                                    checked={
                                      childRow.doseStrengthBeforeRadio === 3
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthBeforeRadio",
                                      )
                                    }
                                  />
                                  <input
                                    className="sub-input-dash"
                                    type="text"
                                    value={
                                      childRow.doseStrengthBeforeRadio === 3
                                        ? childRow.doseStrengthBeforeUnit || ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      // Step 1: Select this radio
                                      onDosageChange(
                                        { target: { value: "3" } },
                                        childIdx,
                                        "doseStrengthBeforeRadio",
                                      );
                                      // Step 2: Update value with validation
                                      onDosageChange(
                                        {
                                          target: {
                                            value: cleanDecimalInput(
                                              e.target.value,
                                            ),
                                          },
                                        },
                                        childIdx,
                                        "doseStrengthBeforeUnit",
                                      );
                                    }}
                                    maxLength={10}
                                    style={{
                                      width: "80px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                  <span className="radio-text-padding">
                                    {" "}
                                    mg/m²
                                  </span>
                                </label>
                              </div>

                              {/* Unknown */}
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={`${childIdx}_b_99`}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblB_${childIdx}`}
                                    value="99"
                                    checked={
                                      childRow.doseStrengthBeforeRadio === 99
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthBeforeRadio",
                                      )
                                    }
                                  />
                                  <span className="radio-text-padding">
                                    Unknown
                                  </span>
                                </label>
                              </div>
                            </div>

                            {/* Column B Validations */}
                            <ErrorField
                              show={childRow.showColBError}
                              message={
                                NDMMTreatmentCohort_Msgs.radioOptionError
                              }
                              style={{ paddingLeft: "0px" }}
                            />
                            <ErrorField
                              show={childRow.showColBValueError}
                              message={
                                NDMMTreatmentCohort_Msgs.lenalidomideDoseStrengthBeforeError
                              }
                              style={{ paddingLeft: "0px" }}
                            />
                            <ErrorField
                              show={childRow.showColBRangeError}
                              message={
                                NDMMTreatmentCohort_Msgs.lenalidomideRangeError
                              }
                              style={{ paddingLeft: "0px" }}
                            />
                            <ErrorField
                              show={childRow.showColBSameValueError}
                              message={NDMMTreatmentCohort_Msgs.SameUnitError}
                              style={{ paddingLeft: "0px" }}
                            />
                          </td>

                          {/* ===== COLUMN C - Dose After Modification ===== */}
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              verticalAlign: "top",
                            }}
                          >
                            <div>
                              {/* mg */}
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={`${childIdx}_c_1`}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblC_${childIdx}`}
                                    value="1"
                                    checked={
                                      childRow.doseStrengthAfterRadio === 1
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthAfterRadio",
                                      )
                                    }
                                  />
                                  <input
                                    className="sub-input-dash"
                                    type="text"
                                    value={
                                      childRow.doseStrengthAfterRadio === 1
                                        ? childRow.doseStrengthAfterUnit || ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      // Step 1: Select this radio
                                      onDosageChange(
                                        { target: { value: "1" } },
                                        childIdx,
                                        "doseStrengthAfterRadio",
                                      );
                                      // Step 2: Update value with validation
                                      onDosageChange(
                                        {
                                          target: {
                                            value: cleanDecimalInput(
                                              e.target.value,
                                            ),
                                          },
                                        },
                                        childIdx,
                                        "doseStrengthAfterUnit",
                                      );
                                    }}
                                    maxLength={10}
                                    style={{
                                      width: "80px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                  <span className="radio-text-padding">
                                    {" "}
                                    mg
                                  </span>
                                </label>
                              </div>

                              {/* mg/kg */}
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={`${childIdx}_c_2`}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblC_${childIdx}`}
                                    value="2"
                                    checked={
                                      childRow.doseStrengthAfterRadio === 2
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthAfterRadio",
                                      )
                                    }
                                  />
                                  <input
                                    className="sub-input-dash"
                                    type="text"
                                    value={
                                      childRow.doseStrengthAfterRadio === 2
                                        ? childRow.doseStrengthAfterUnit || ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      // Step 1: Select this radio
                                      onDosageChange(
                                        { target: { value: "2" } },
                                        childIdx,
                                        "doseStrengthAfterRadio",
                                      );
                                      // Step 2: Update value with validation
                                      onDosageChange(
                                        {
                                          target: {
                                            value: cleanDecimalInput(
                                              e.target.value,
                                            ),
                                          },
                                        },
                                        childIdx,
                                        "doseStrengthAfterUnit",
                                      );
                                    }}
                                    maxLength={10}
                                    style={{
                                      width: "80px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                  <span className="radio-text-padding">
                                    {" "}
                                    mg/kg
                                  </span>
                                </label>
                              </div>

                              {/* mg/m² */}
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={`${childIdx}_c_3`}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblC_${childIdx}`}
                                    value="3"
                                    checked={
                                      childRow.doseStrengthAfterRadio === 3
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthAfterRadio",
                                      )
                                    }
                                  />
                                  <input
                                    className="sub-input-dash"
                                    type="text"
                                    value={
                                      childRow.doseStrengthAfterRadio === 3
                                        ? childRow.doseStrengthAfterUnit || ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      // Step 1: Select this radio
                                      onDosageChange(
                                        { target: { value: "3" } },
                                        childIdx,
                                        "doseStrengthAfterRadio",
                                      );
                                      // Step 2: Update value with validation
                                      onDosageChange(
                                        {
                                          target: {
                                            value: cleanDecimalInput(
                                              e.target.value,
                                            ),
                                          },
                                        },
                                        childIdx,
                                        "doseStrengthAfterUnit",
                                      );
                                    }}
                                    maxLength={10}
                                    style={{
                                      width: "80px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                  <span className="radio-text-padding">
                                    {" "}
                                    mg/m²
                                  </span>
                                </label>
                              </div>

                              {/* Unknown */}
                              <div>
                                <label className="long-text-option">
                                  <input
                                    type="radio"
                                    id={`${childIdx}_c_99`}
                                    name={`q${questionNumber.replace(/\./g, "")}_rblC_${childIdx}`}
                                    value="99"
                                    checked={
                                      childRow.doseStrengthAfterRadio === 99
                                    }
                                    onChange={(e) =>
                                      onDosageChange(
                                        e,
                                        childIdx,
                                        "doseStrengthAfterRadio",
                                      )
                                    }
                                  />
                                  <span className="radio-text-padding">
                                    Unknown
                                  </span>
                                </label>
                              </div>
                            </div>

                            {/* Column C Validations */}
                            <ErrorField
                              show={childRow.showColCError}
                              message={
                                NDMMTreatmentCohort_Msgs.radioOptionError
                              }
                              style={{ paddingLeft: "0px" }}
                            />
                            <ErrorField
                              show={childRow.showColCValueError}
                              message={
                                NDMMTreatmentCohort_Msgs.lenalidomideDoseStrengthAfterError
                              }
                              style={{ paddingLeft: "0px" }}
                            />
                            <ErrorField
                              show={childRow.showColCRangeError}
                              message={
                                NDMMTreatmentCohort_Msgs.lenalidomideRangeError
                              }
                              style={{ paddingLeft: "0px" }}
                            />
                            <ErrorField
                              show={childRow.showColCSameValueError}
                              message={NDMMTreatmentCohort_Msgs.SameUnitError}
                              style={{ paddingLeft: "0px" }}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ))}

            {/* Add More Row Button */}
            {dosageList.length < 500 && (
              <div className="sub-question-bot-sapce-ul">
                <div className="answer-list-text" onClick={() => onAddRow()}>
                  <a>
                    <img width="18px" src="../Assets/images/plus.png" alt="" />
                  </a>
                  <a className="radio-text-padding">
                    Click here to add another lenalidomide dose strength
                    modification
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NDMMDosageModification;
